var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg62(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-3893.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 74,
    transform: "translate(3868.000000, 3.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6959238,5.99771429 C11.200451,5.99771429 11.6864061,6.0772447 12.141936,6.22445253 L12.2640706,6.26668023 C11.1826923,7.64874187 10.4843822,9.34501641 10.3289637,11.1957333 L10.3289637,11.1957333 L9.79656655,11.1957333 C8.48858143,11.1957333 7.27543364,11.6006703 6.27554742,12.2919862 C6.09588545,11.7940872 5.99771429,11.2564681 5.99771429,10.6959238 C5.99771429,8.10121265 8.10121265,5.99771429 10.6959238,5.99771429 Z",
    id: "Combined-Shape",
    fill: "#FED100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 0,
    y: 9.89622857,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(4.723126, 4.723160) rotate(45.000000) translate(-4.723126, -4.723160) ",
    x: 2.473983,
    y: 3.92346459,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 9.89622857,
    y: 0,
    width: 1.59939048,
    height: 4.49828571,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1792798,9.09653333 C28.5088321,9.09653333 30.5660975,10.5142928 31.4133603,12.6157116 L31.4966534,12.8355084 L31.7620571,13.5854 L22.3259956,13.5862476 L19.9310571,22.0914 L18.6583461,22.091581 C16.8533339,22.091581 15.3929905,20.637635 15.3929905,18.8464177 C15.3929905,17.1170629 16.7540775,15.7019342 18.472957,15.6063954 L18.658446,15.6012544 L20.4458648,15.6012544 L20.5618206,14.2277778 C20.8053278,11.3393786 23.242699,9.09653333 26.1792798,9.09653333 Z M19.5795383,4.1984 C22.2063347,4.1984 24.5914327,5.5107583 26.0142124,7.59896857 C22.4331534,7.6799137 19.5031828,10.387943 19.0918133,13.8636762 L19.0676901,14.1018258 L18.6583461,14.1018258 C16.0261492,14.1018258 13.8935619,16.2260163 13.8935619,18.8464177 C13.8935619,20.0183102 14.3200664,21.0907963 15.0269082,21.9184774 L15.1826119,22.0920376 L9.79656655,22.091581 C7.20125562,22.091581 5.09805714,19.9885824 5.09805714,17.3933714 C5.09805714,14.870444 7.08593961,12.8123857 9.58145645,12.6999959 L9.79656655,12.6951619 L11.7077382,12.6951619 L11.8230942,11.3211855 C12.1599659,7.30951436 15.5267828,4.1984 19.5795383,4.1984 Z M33.7970767,13.7646543 C36.1110949,13.7646543 37.984381,15.6300434 37.984381,17.9281676 C37.984381,20.1564578 36.2229072,21.9781239 34.006188,22.0864817 L33.7970767,22.091581 L32.9800571,22.0914 L34.4956386,19.5730897 L29.2737361,19.5730897 L31.8430571,13.8124 L31.9125949,14.006862 L33.1408268,13.815235 C33.3560448,13.7816478 33.5751613,13.7646543 33.7970767,13.7646543 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FED100",
    points: "25.3961965 24.5730897 20.7909333 24.5730897 23.461986 15.0862476 29.6330386 15.0862476 26.961986 21.0730897 31.8435649 21.0730897 22.8172491 36.0862476"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg62);
export default __webpack_public_path__ + "static/media/62.79f005abcda153ab33c60a7fc4967a98.svg";
export { ForwardRef as ReactComponent };